export const getProjectAdditionalCosts = (
  project,
  numberOfHighlightedCosts = 2
) => {
  const additionalCosts = project?.additional_costs ?? [];

  const sortedCosts = additionalCosts.sort(
    (a, b) => b.estimated_cost - a.estimated_cost
  );

  const highlightedCosts = sortedCosts.slice(0, numberOfHighlightedCosts);

  const othersCosts = sortedCosts.slice(
    numberOfHighlightedCosts,
    sortedCosts.length
  );

  const othersTotalCost = othersCosts.reduce(
    (sum, cost) => sum + (cost.estimated_cost ?? 0),
    0
  );

  return {
    highlighted: highlightedCosts,
    others: othersCosts,
    othersTotalCost,
  };
};

export const getAdditionalCostTitle = ({ cost = {}, costTypes = [] }) => {
  if (!cost) return "";

  if (cost.description) return cost.description;

  if (cost.type && costTypes?.length > 0) {
    return costTypes.find(({ slug }) => slug === cost.type)?.name ?? "";
  }

  return "";
};
